import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { color } from "../../../styles/color";
import { Tabs, Dropdown } from "antdv5";
import type { MenuProps } from "antdv5";
import type { IGameName } from "../../../client_types";
import { DownOutlined } from "@ant-design/icons";
import type { Obj } from "../../../client_types";

interface IProps {
  games: Obj[];
  gameName: IGameName;
  handleList: (key: "match" | "train") => void;
  listItemOnClick: (matchID: number, matchName: string) => void;
}

const TabsBar = ({ gameName, handleList, games, listItemOnClick }: IProps) => {
  const [items, setItems] = React.useState<MenuProps["items"]>([]);

  React.useEffect(() => {
    const items =
      games && games.length !== 0
        ? games.map((data) => ({
            key: uuidv4(),
            label: (
              <div
                style={{ color: `${color.markedSecondary}` }}
                onClick={() => listItemOnClick(data.MatchID, data.MatchName)}
              >
                {data.MatchID} - {data.MatchName}
              </div>
            ),
          }))
        : [];
    setItems(items);
  }, [games]);

  return (
    <div className="tabsBar">
      <Tabs
        items={[
          {
            label: "比赛列表",
            key: "match",
          },
          {
            label: "训飞列表",
            key: "train",
          },
        ]}
        onChange={(key: string) => handleList(key === "match" ? key : "train")}
        type="card"
      />
      <Dropdown menu={{ items }} trigger={["click"]}>
        <button
          className="ant-dropdown-link"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          {gameName.matchID === ""
            ? `${gameName.matchName}`
            : `${gameName.matchID} - ${gameName.matchName}`}
          <DownOutlined />
        </button>
      </Dropdown>
    </div>
  );
};
export default TabsBar;
